import {
  LOAD_CUSTOMERS,
  CustomersState,
  CustomerAction,
  FETCH_CUSTOMERS,
  REMOVE_CUSTOMER,
  PERSIST_CUSTOMER,
} from "./CustomerTypes";
import { Customer } from "msd-capacity-planning-model";
const initialState: CustomersState = {
  items: {},
  synching: true,
};

export default function customersReducer(
  state = initialState,
  action: CustomerAction
): CustomersState {
  switch (action.type) {
    case FETCH_CUSTOMERS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_CUSTOMER:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_CUSTOMER:
      return {
        ...state,
        synching: true,
      };

    case LOAD_CUSTOMERS:
      return {
        ...state,
        items: action.items.reduce((all: { [id: string]: Customer }, team) => {
          // Filter out customers with offboardingDate older than a year
          const oneYearAgo = new Date();
          oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

          // Only add the customer if they don't have an offboardingDate or it's less than a year old
          if (!team.offboardingDate || (
            team.offboardingDate &&
            new Date(team.offboardingDate.year, team.offboardingDate.month - 1, team.offboardingDate.day) >= oneYearAgo
          )) {
            all[team.id] = team;
          }
          return all;
        }, {}),
        synching: false,
      };
    default:
      return state;
  }
}
